import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AttachmentIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8 22.99a6.96 6.96 0 0 1-4.95-2.05A6.96 6.96 0 0 1 1 15.99c0-1.87.73-3.63 2.05-4.95l8.57-8.57c.94-.95 2.2-1.47 3.54-1.47 1.34 0 2.59.52 3.54 1.46.95.95 1.47 2.2 1.47 3.54 0 1.32-.53 2.61-1.46 3.54l-8.59 8.57C9 19.23 7 19.23 5.88 18.11c-.56-.56-.88-1.33-.88-2.12s.31-1.56.88-2.12l8.48-8.48a.996.996 0 1 1 1.41 1.41l-8.49 8.48a.99.99 0 0 0-.29.71c0 .27.11.52.29.71.38.37 1.04.38 1.42 0l8.59-8.57c.56-.56.88-1.33.88-2.12 0-.8-.31-1.56-.88-2.12-.57-.57-1.32-.88-2.12-.88s-1.56.31-2.12.88l-8.58 8.56C3.53 13.4 3 14.65 3 15.99c0 1.34.52 2.59 1.47 3.54.94.94 2.2 1.46 3.54 1.46 1.34 0 2.59-.52 3.54-1.46l9.19-9.19a.996.996 0 1 1 1.41 1.41l-9.19 9.19a6.96 6.96 0 0 1-4.95 2.05H8Z" />
    </Icon>
  )
);
export default AttachmentIcon;
